import { InlineText2 } from '@cian/ui-kit';
import * as React from 'react';

export const OnlyAfterPremiumExpiration = () => (
  <InlineText2 color="superblack_100">Дождитесь окончания Премиум-публикации</InlineText2>
);
